import type { CourseChatPersona } from '../types/course';
import type { TFunction } from 'i18next';
/** The server names the own chart «Я» when the profile has no first name. */
const NO_NAME = 'Я';

/** The name to show for a chart: its own name, or the word for «Я» when the own chart has none. */
export function personaName(chart: { name: string; isSelf: boolean }, selfLabel: string): string {
  const name = chart.name.trim();
  if (chart.isSelf && (name === '' || name === NO_NAME)) return selfLabel;
  return name || selfLabel;
}

/** Course labels never fall back to a person's chart name. */
export function coursePersonaLabel(persona: CourseChatPersona | null | undefined, t: TFunction): string {
  if (!persona) return t('course:title');
  return t(persona.lessonNumber === null ? 'course:chat.historyExam' : 'course:chat.historyLesson', {
    course: persona.courseTitle, number: persona.lessonNumber, title: persona.itemTitle,
  });
}
